import AuthImpl from '../../serviceImpl/AuthImpl';
import LocalStorageImpl from '../../serviceImpl/LocalStorageImpl';

import {LoginError} from '@/domain/services/Auth';

const loginUseCase = async (
  user: string, 
  password: string,
  t: (key: string) => string
): Promise<void | LoginError> => {
  try {
    // Validar inputs
    if (!user?.trim() || !password?.trim()) {
      return Promise.resolve({
        detail: t('errors.Username and password are required'),
        code: 'MISSING_CREDENTIALS'
      });
    }

    const login = await AuthImpl.login(user, password);

    if (login) {
      if ('access' in login) {
        // Login exitoso
        await LocalStorageImpl.setCredentials(login.access, login.refresh);
        return Promise.resolve();
      }

      if ('detail' in login) {
        // Error de autenticación del servidor
        return Promise.resolve(login);
      }
    }

    // Si login es null/undefined
    return Promise.resolve({
      detail: t('errors.The login request could not be processed'),
      code: 'LOGIN_FAILED'
    });

  } catch (error) {
    console.error('Error in loginUseCase:', error);

    // Si el error tiene la estructura {statusCode, payload: {detail}}
    if (error && typeof error === 'object' && 'payload' in error) {
      const errorWithPayload = error as {statusCode: number, payload: {detail: string}};
      return Promise.resolve({
        detail: errorWithPayload.payload.detail,
        code: `HTTP_${errorWithPayload.statusCode}`
      });
    }

    // Si el error tiene la estructura {detail} directamente
    if (error && typeof error === 'object' && 'detail' in error) {
      const errorWithDetail = error as {detail: string};
      return Promise.resolve({
        detail: errorWithDetail.detail,
        code: 'API_ERROR'
      });
    }

    // Distinguir entre diferentes tipos de errores
    if (error instanceof TypeError && error.message.includes('fetch')) {
      return Promise.resolve({
        detail: t('errors.Connection error. Please check your internet connection'),
        code: 'NETWORK_ERROR'
      });
    }

    if (error instanceof Error) {
      return Promise.resolve({
        detail: error.message,
        code: 'UNEXPECTED_ERROR'
      });
    }

    return Promise.resolve({
      detail: t('errors.An unexpected error has occurred'),
      code: 'UNKNOWN_ERROR'
    });
  }
};

export default loginUseCase;